import {useSelector} from "react-redux";
import React, {useState} from "react";
import TimeCell from "../components/TimeCell";
import {Table} from "antd";

const UserDataSelector = ({dataField, onSelect, selectedIds=[]})=>{
  const userItems = useSelector((state)=>state.user.data[dataField] || []);
  const [selectedRowKeys, setSelectedRowKeys] = useState(selectedIds);

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    onSelect(selectedRowKeys);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: 'title',
      key: 'title',

    },
    {
      title: "Created",
      dataIndex: 'create_timestamp',
      key: 'create_timestamp',
      render: (text, record) => <TimeCell timestamp={record.create_timestamp} />
    }
  ]
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={userItems}
        rowKey="id"
        pagination={false}
        scroll={{ y: 480 }}
      />
  )
}

export default UserDataSelector;